import { METALLIC_LEVEL, PRODUCT_TYPE } from './plans';

const exclusiveProviderOrganization =
    'EPO plans generally offer a local network of providers and moderate expenses for monthly premiums and out-of-pocket costs.';

const healthMaintenanceOrganization =
    'HMO plans generally offer a more limited network of providers with lower monthly premiums.';

const preferredProviderOrganization =
    'PPO plans generally offer a broader network of providers, but can have higher out-of-pocket costs.';

const pointOfService =
    'POS plans offer a local network of providers and require a referral from a primary care doctor before you can go to a specialist.';

export const productTypeTooltipMap = new Map<PRODUCT_TYPE, string>([
    [PRODUCT_TYPE.EPO, exclusiveProviderOrganization],
    [PRODUCT_TYPE.HMO, healthMaintenanceOrganization],
    [PRODUCT_TYPE.PPO, preferredProviderOrganization],
    [PRODUCT_TYPE.POS, pointOfService],
]);

export const qualifyingLifeEventTooltip =
    'Common qualifying life events include having a baby, getting married, or moving to a new place.';

export const networkTooltip =
    "The facilities, doctors, and other health care professionals that have agreed to offer care to a plan's members at a lower cost.";

export const csrTooltip =
    'A cost-sharing reduction (CSR) is a financial assistance program that can lower out-of-pocket health care costs for eligible individuals.';

export const subsidyTooltip = 'Financial assistance that can help lower monthly premiums and out-of-pocket costs.';

export const subsidySavingsTooltip =
    'This estimate is based on the household size and yearly income you provided. To make changes, select Edit.';

export const coinsuranceTooltip = "The percentage you'd pay for covered services after you meet your deductible.";

export const individualOutOfPocket =
    "The highest amount you'd pay for covered medical services within a plan year, after which eligible costs would be covered 100%.";

export const familyMemberOutOfPocket =
    'The highest amount a covered family member would pay for covered medical services within a plan year, after which eligible costs would be covered 100%.';

export const familyOutOfPocket =
    'The highest amount all covered members would pay collectively for covered medical services within a plan year, after which eligible costs would be covered 100%.';

export const deductibleTooltip =
    "The base amount you'd pay for a covered service before your plan starts paying for all or part of the remaining service cost.";

export const familyMemberDeductible =
    'The base amount a covered family member would pay for a covered service before your plan starts paying for all or part of the remaining service cost.';

export const familyDeductible =
    'The base amount covered members would collectively pay for a covered service before your plan starts paying for all or part of the remaining service cost.';

export const prescriptionDeductible =
    "The base amount a covered member would pay for a prescription before copayments or coinsurance. For integrated prescription deductibles, you'd pay your medical deductible before copayments or coinsurance.";

export const primaryCareTooltip = 'Includes medical services for preventative or routine care.';

export const specialistTooltip = 'Includes medical services like surgery, lab work, therapy and radiology.';

export const urgentcareTooltip =
    'Includes medical services provided for a sudden or unexpected condition requiring prompt diagnosis or treatment to prevent chronic illness, prolonged impairment, or a more hazardous treatment.';

export const emergencyTooltip =
    'Includes medical services that screen for or treat an emergency health condition, until the condition is stabilized.';

export const overallStarRatingTooltip =
    'Based on ratings for member experience, medical care, and plan administration.';

export const memberExperienceTooltip =
    'Based on member satisfaction surveys about their health care, doctors, and ease of getting appointments and services.';

export const medicalCareTooltip =
    'Based on providers improving or maintaining the health of their patients with regular screenings, tests, vaccines, and condition monitoring.';

export const planAdministrationTooltip =
    'Based on how well a plan is run, including customer service, access to needed information, and providers ordering appropriate tests and treatment.';

export const goldMetalTooltip =
    "On average, Gold plans pay for 80% of medical costs. This plan might be right for you if you're willing to pay a higher monthly premium to have more costs covered when you get medical services.";

export const silverMetalTooltip =
    "On average, silver plans pay for 70% of medical costs. This plan might be right for you if you're willing to pay a moderate monthly premium to have more costs covered when you get routine medical care.";

export const bronzeMetalTooltip =
    "On average, Bronze plans pay for 60% of medical costs on average. This plan might be right for you if only want coverage for major medical incidents. Your monthly premium will be low, but you'll have to pay out-of - pocket for most routine care.";

export const metalPlanTooltipMap = new Map<METALLIC_LEVEL, string>([
    [METALLIC_LEVEL.GOLD, goldMetalTooltip],
    [METALLIC_LEVEL.SILVER, silverMetalTooltip],
    [METALLIC_LEVEL.BRONZE, bronzeMetalTooltip],
]);

export const easyPricingTooltip = `<p style="line-height: var(--lh-line-height-1-333, 16px);">Consider plans with easy pricing</p><p style="line-height: var(--lh-line-height-1-333, 16px);">Marketplace plans marked easy pricing:</p><ul style="line-height: var(--lh-line-height-1-333, 16px); padding-top: 0px;"><li style="line-height: var(--lh-line-height-1-333, 16px);"><ul style="line-height: var(--lh-line-height-1-333, 16px);">Include some benefits before you reach the deductible. As soon as coverage starts, you'll pay only a copayment for:<li style="line-height: var(--lh-line-height-1-333, 16px);">Doctor and specialist visits, including mental health</li><li style="line-height: var(--lh-line-height-1-333, 16px);">Urgent care</li><li style="line-height: var(--lh-line-height-1-333, 16px);">Physical, speech, and occupational therapy</li><li style="line-height: var(--lh-line-height-1-333, 16px);">Generic and most preferred drugs</li></ul></li><li style="line-height: var(--lh-line-height-1-333, 16px);"><ul style="line-height: var(--lh-line-height-1-333, 16px);">Are easier to compare because they have the same out-of-pocket costs within their health plan category, like:<li style="line-height: var(--lh-line-height-1-333, 16px);">Deductibles</li><li style="line-height: var(--lh-line-height-1-333, 16px);">Out-of-pocket maximums</li><li style="line-height: var(--lh-line-height-1-333, 16px);">Copayments/coinsurance</li></ul></li></ul>`;
